import { render, staticRenderFns } from "./ReportHistory.vue?vue&type=template&id=d87c2af2&scoped=true"
import script from "./ReportHistory.vue?vue&type=script&lang=js"
export * from "./ReportHistory.vue?vue&type=script&lang=js"
import style0 from "./ReportHistory.vue?vue&type=style&index=0&id=d87c2af2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87c2af2",
  null
  
)

export default component.exports